import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * This component should wrap the content that you wish to use as the base layer. All overlayed elements will be atop this element.
 */
function PositionedOverlayBase(_ref) {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const rootClassName = clsx({
    'positioned-overlay-base': true
  }, className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "positionedOverlayBase",
    className: rootClassName
  }, rest), children);
}
export default PositionedOverlayBase;